export class User {
    constructor(public id: string, public isActive: boolean, public email: string, public name: string, public roles: string[]) {
    }
}
